





























































































































































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { State, Action, Getter, Mutation } from 'vuex-class'
import VueBarcode from 'vue-barcode'

import axios from 'axios'
import { jsPDF } from 'jspdf'
import 'svg2pdf.js'

import _capitalize from 'lodash/capitalize'
import _get from 'lodash/get'
import _keys from 'lodash/keys'
import _reduce from 'lodash/reduce'
import _startsWith from 'lodash/startsWith'
import _trimStart from 'lodash/trimStart'
import _lowerCase from 'lodash/lowerCase'
import _upperCase from 'lodash/upperCase'

import Dayjs from 'dayjs'
import timezone from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'

import SearchInput from '@/components/SearchInput.vue'
import CheckInHistory from './CheckInHistory.vue'
import OfferItemsTable from './OfferItemsTable.vue'

import { Book, Condition, CONDITION_TYPE } from '@/types'
import { isValidISBN, normalizeISBN } from '@/utils/isbn.util'
import { BASE_URL } from '@/config'

Dayjs.extend(utc)
Dayjs.extend(timezone)

const OFFER_PREFIX = 152224 // FMO: FranklinMediaOffer
const SHIPMENT_PREFIX = 152228 // FMS: FranklinMediaShipment

@Component({
  components: {
    CheckInHistory,
    OfferItemsTable,
    SearchInput,
    VueBarcode,
  },
  methods: {
    _capitalize,
    _get,
    _keys,
    _upperCase,
  },
})
export default class CheckInPage extends Vue {
  public $refs: any = {
    searchInput: HTMLFormElement,
  }

  @Action('getConditions', { namespace: 'books' }) private getConditions: any
  @Getter('getConditionsGroupByType', { namespace: 'books' }) private conditionsGroupByType: any // { conditionType: Condition[], ... }
  @Getter('getSelectedCondition', { namespace: 'checkin' }) private selectedCondition:
    | Condition
    | undefined
  @Mutation('setSelectedCondition', { namespace: 'checkin' })
  private setSelectedCondition: ((condition: Condition) => void) | undefined

  private helperKeywordText: string = 'Scan for a shipment or book'

  private requestGetShipment: boolean = false
  private requestGetCheckBook: boolean = false
  private requestCheckInBook: any = null
  private requestPrintInventoryId: string | null = null
  private requestDeleteInventoryId: string | null = null

  private shipment: any = null
  private checkBook: any = null
  private inventory: any = null
  private offerCode: string | undefined
  private shipmentCode: string | undefined
  private offerId: string | null = null
  private isbn: string = ''
  private checkedIn: boolean = false
  private searchKeyword: string = ''
  private expandedCheckInHistory: boolean = false
  private expandedConditionType: string = ''

  private mounted(): void {
    this.getConditions({ offset: 0 })
      .then(() => {})
      .catch(err => {})
  }

  private destroyed(): void {}

  @Watch('conditionsGroupByType')
  private conditionsGroupByTypeChanged(newVal: any | undefined) {
    if (newVal && this.setSelectedCondition) {
      const usedConditions = newVal[CONDITION_TYPE.USED]
      const selectedCondition = this.selectedCondition
      if (usedConditions && usedConditions.length) {
        if (selectedCondition) {
          const tempIndex = usedConditions.findIndex(c => c.id === selectedCondition.id)
          if (tempIndex < 0) {
            this.setSelectedCondition(usedConditions[0])
          }
        } else {
          this.setSelectedCondition(usedConditions[0])
        }
      }
    }
  }

  get offerCreatedDay() {
    const temp = _get(this.shipment, ['offerRevision', 'offer', 'createdAt']) || ''
    return temp ? Dayjs(temp).format('ddd') : ''
  }

  get offerCreatedDate() {
    const temp = _get(this.shipment, ['offerRevision', 'offer', 'createdAt']) || ''
    return temp ? Dayjs(temp).format('MM/DD') : ''
  }

  private getInventoryDate(inventory): string {
    const temp = _get(inventory, ['updatedAt'])
    return temp
      ? `${Dayjs(temp)
          .tz('America/Chicago')
          .format('MM/DD/YYYY h:mm:ss A')} CST`
      : ''
  }

  private handleSearch(keyword: string): void {
    this.searchKeyword = keyword
    if (!keyword) {
      if (this.isbn) {
        this.isbn = ''
        this.checkBook = null
      } else {
        this.isbn = ''
        this.offerCode = undefined
        this.shipmentCode = undefined
        this.shipment = null
      }
    } else {
      if (keyword.length < 15) {
        if (!this.shipmentCode && !this.offerCode) {
          Vue.$toast.error(`Please enter Shipping Receipt.`)
          return
        }
        this.handleSearchISBN(keyword)
      } else {
        this.handleSearchShipment(keyword)
      }
    }
  }

  private handleSearchShipment(keyword: string): void {
    if (_startsWith(keyword, OFFER_PREFIX)) {
      this.offerCode = keyword
    } else if (_startsWith(keyword, SHIPMENT_PREFIX)) {
      this.shipmentCode = keyword
    } else {
      Vue.$toast.error('Invalid Shipping Receipt. Please enter valid Shipping Receipt.')
      return
    }

    this.helperKeywordText = 'Searching...'
    this.requestGetShipment = true
    this.checkedIn = false
    this.inventory = null

    const path = `${BASE_URL}/check-in/shipment`

    axios
      .get(path, {
        params: {
          offerCode: this.offerCode,
          shipmentCode: this.shipmentCode,
        },
      })
      .then(response => {
        this.shipment = _get(response, ['data'])
        this.offerId = _get(this.shipment, ['offerRevision', 'offer', 'id']) || null
        if (!this.shipment) {
          Vue.$toast.error('No matches found.')
        }
      })
      .catch(err => {
        this.shipment = null
      })
      .finally(() => {
        this.searchKeyword = ''
        this.helperKeywordText = 'Scan for a shipment or book'
        this.requestGetShipment = false
      })
  }

  private handleSearchISBN(keyword: string): void {
    if (!keyword) {
      Vue.$toast.error('Please enter ISBN to search.')
      return
    }

    const normalizedISBN: string = normalizeISBN(keyword)
    if (!isValidISBN(normalizedISBN)) {
      Vue.$toast.error('Please enter a valid ISBN to search.')
      return
    }

    this.searchKeyword = normalizedISBN
    this.isbn = normalizedISBN

    if (!this.offerId) {
      Vue.$toast.error('Please enter a valid Shipping Receipt.')
      return
    }

    this.helperKeywordText = 'Searching...'
    this.requestGetCheckBook = true
    this.checkedIn = false
    this.inventory = null

    const path = `${BASE_URL}/check-in/checkbook`

    axios
      .get(path, {
        params: {
          offerId: this.offerId,
          isbn: normalizedISBN,
        },
      })
      .then(response => {
        this.checkBook = _get(response, ['data'])
        if (!this.checkBook) {
          Vue.$toast.error('No matches found.')
        }
      })
      .catch(err => {
        this.checkBook = null
      })
      .finally(() => {
        this.searchKeyword = ''
        this.helperKeywordText = 'Scan for a shipment or book'
        this.requestGetCheckBook = false
      })
  }

  private handleClickCheckIn(condition: Condition | null) {
    if (this.requestCheckInBook) return
    if (!condition) {
      Vue.$toast.error('Please select a condition.')
      return
    }

    const payload = {
      isbn: _get(this.checkBook, ['book', 'isbn']),
      bookId: _get(this.checkBook, ['book', 'id']),
      conditionId: condition.id,
      sellerId:
        _get(this.shipment, ['seller', 'id']) ||
        _get(this.shipment, ['offerRevision', 'offer', 'seller', 'id']),
      offerId: _get(this.shipment, ['offerRevision', 'offerId']),
    }

    if (!payload.isbn) {
      Vue.$toast.error('ISBN is required.')
      return
    }

    if (!payload.bookId) {
      Vue.$toast.error('Book is required.')
      return
    }

    if (!payload.conditionId) {
      Vue.$toast.error('Please select a condition.')
      return
    }

    if (!payload.sellerId) {
      Vue.$toast.error('Seller is required.')
      return
    }

    this.requestCheckInBook = condition
    this.expandedConditionType = ''
    this.checkedIn = false
    this.inventory = null
    const path = `${BASE_URL}/check-in`

    axios
      .post(path, payload)
      .then(response => {
        this.inventory = _get(response, ['data']) || null
        if (!this.inventory) {
          Vue.$toast.error('Check-in failed. Please try again.')
        } else {
          this.checkedIn = true
          Vue.$toast.success('The book has been checked in.')
          setTimeout(() => {
            this.printLabels(this.inventory.id)
          }, 500)
        }
      })
      .catch(err => {
        console.log('err ====', err)
        this.inventory = null
      })
      .finally(() => {
        this.requestCheckInBook = null
      })
  }

  private handleUndoCheckInOfferItem(offerItem) {
    this.checkedIn = false
    const path = `${BASE_URL}/check-in/undo`
    axios
      .post(path, {
        isbn: offerItem.isbn,
        bookId: offerItem.book_id,
        conditionId: offerItem.condition_id,
        sellerId: offerItem.seller_id,
        offerId: offerItem.offer_id,
      })
      .then(response => {
        const temp = _get(response, ['data'])
        if (temp) {
          this.checkedIn = true
        } else {
          Vue.$toast.error('Undo Check-in failed. Please try again.')
        }
      })
      .catch(err => {})
      .finally(() => {
        if (_get(this.$refs.searchInput.$refs, 'keyword')) {
          this.$nextTick(() => this.$refs.searchInput.$refs.keyword.$el.focus())
        }
      })
  }

  private handleUndoCheckIn(inventoryId) {
    this.requestDeleteInventoryId = inventoryId
    const path = `${BASE_URL}/check-in?id=${inventoryId}`
    axios
      .delete(path)
      .then(response => {
        const temp = _get(response, ['data'])
        if (temp) {
          if (this.requestDeleteInventoryId === _get(this.inventory, 'id')) {
            this.inventory = null
          }
        }
      })
      .catch(err => {
        Vue.$toast.error('Undo Check-in failed. Please try again.')
      })
      .finally(() => {
        this.requestDeleteInventoryId = null
      })
  }

  private async printLabels(elementId) {
    // window.print();
    this.requestPrintInventoryId = elementId
    const pdf = new jsPDF('l', 'mm', [25.4, 76.2])
    pdf.setFontSize(14)
    const labelWrapper = document.getElementById(elementId) as HTMLElement
    const svgEle = labelWrapper.getElementsByTagName('svg')
    pdf
      .svg(svgEle[0], {
        x: 1,
        y: 1,
        width: 34, // 314px, 78.8mm
        height: 24, // 118px, 27.8mm
      })
      .then(() => {
        pdf
          .svg(svgEle[1], {
            x: 35,
            y: 1,
            width: 40, // 314px, 78.8mm
            height: 24, // 118px, 27.8mm
          })
          .then(() => {
            // pdf.save();
            const pdfBase64 = pdf.output('datauristring')
            const path = `${BASE_URL}/check-in/print`
            axios
              .post(path, {
                pdfBase64: _trimStart(
                  pdfBase64,
                  'data:application/pdf;filename=generated.pdf;base64,'
                ),
              })
              .then(response => {
                const temp = _get(response, ['data', 'data'])
                if (temp) {
                  Vue.$toast.success('Print Job has been created.')
                } else {
                  Vue.$toast.error('Print Job failed. Please try again.')
                }

                if (_get(this.$refs.searchInput.$refs, 'keyword')) {
                  this.$nextTick(() => this.$refs.searchInput.$refs.keyword.$el.focus())
                }
              })
              .catch(err => {})
              .finally(() => {
                this.requestPrintInventoryId = null
              })
          })
      })
  }
}
